module.exports = __webpack_public_path__ + "static/media/FounderOfColorActiveUpdated.f6e6a06a.svg";